"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationType = void 0;
var NotificationType;
(function (NotificationType) {
    NotificationType[NotificationType["ORDER"] = 1] = "ORDER";
    NotificationType[NotificationType["TICKET"] = 2] = "TICKET";
    NotificationType[NotificationType["PROMO"] = 3] = "PROMO";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
